<div class="charts-tooltip_inner_range">
    {{from}} - {{till}}
</div>